import { useState } from 'react';
import { Textarea } from '@/components/ui/textarea';
import type { DayNote } from '../api';
import { DAY_NAMES } from './dayNames';

type NotesRowProps = {
  notes: DayNote[];
  /** The weekdays shown (1–5), in column order. */
  days: number[];
  mode: 'edit' | 'board';
  onChange?: (weekday: number, note: string) => void;
};

type NoteFieldProps = { label: string; value: string; onSave: (note: string) => void };

/** "Notities": one free line per day under the timetable; saved when the field is left. */
export function NotesRow({ notes, days, mode, onChange }: NotesRowProps) {
  const noteOf = (weekday: number) => notes.find((note) => note.weekday === weekday)?.note ?? '';
  return (
    <div role="row" className="contents">
      <div role="rowheader" className="px-2 py-1 font-semibold" style={{ fontFamily: 'var(--font-heading)' }}>
        Notities
      </div>
      {days.map((weekday) =>
        mode === 'edit' && onChange ? (
          <NoteField key={weekday} label={`Notitie ${DAY_NAMES[weekday - 1] ?? ''}`} value={noteOf(weekday)} onSave={(note) => onChange(weekday, note)} />
        ) : (
          <div key={weekday} role="gridcell" className="whitespace-pre-wrap px-2 py-1 text-[0.9em]">
            {noteOf(weekday)}
          </div>
        ),
      )}
    </div>
  );
}

function NoteField({ label, value, onSave }: NoteFieldProps) {
  const [draft, setDraft] = useState(value);
  return (
    <div role="gridcell" className="px-1 py-1">
      <Textarea
        aria-label={label}
        value={draft}
        maxLength={500}
        rows={2}
        onChange={(event) => setDraft(event.target.value)}
        onBlur={() => draft.trim() !== value && onSave(draft.trim())}
        className="auto-grow min-h-11 resize-none text-[0.9em]"
      />
    </div>
  );
}
